import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { styles } from './MainPage.styles';
import AnimatedCounter from './AnimatedCounter';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export default function MetricsSection() {
  const [metrics, setMetrics] = useState({
    facilities_count: 0,
    rejected_packages: 0,
    states_covered: 0,
    years_experience: 35
  });

  const hasFetched = useRef(false);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;

    const fetchMetrics = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}/bookpolicyguard/fetch_matrics_details`);
        // Assuming your backend returns keys like { facilities_count: 1800, ... }
        setMetrics(response.data);
      } catch (error) {
        console.error("Error fetching metrics:", error);
      }
    };
    fetchMetrics();
  }, []);

  return (
    <section style={styles.metrics}>
      <div style={styles.metricsGrid}>
        <div style={styles.metricCard}>
          <div style={styles.metricNumber}>
            <AnimatedCounter targetValue={metrics.facilities_count.toString()} />
          </div>
          <div style={styles.metricLabel}>Facilities in Database</div>
        </div>
        
        <div style={styles.metricCard}>
          <div style={styles.metricNumber}>
            <AnimatedCounter targetValue={metrics.rejected_packages.toString()} />
          </div>
          <div style={styles.metricLabel}>Rejected Packages</div>
        </div>
        
        <div style={styles.metricCard}>
          <div style={styles.metricNumber}>
            <AnimatedCounter targetValue={metrics.states_covered.toString()} />
          </div>
          <div style={styles.metricLabel}>States Covered</div>
        </div>
        
        <div style={styles.metricCard}>
          <div style={styles.metricNumber}>
            <AnimatedCounter targetValue={metrics.years_experience.toString()} />
          </div>
          <div style={styles.metricLabel}>Years Experience</div>
        </div>
      </div>
    </section>
  );
}